<template>
  <fieldset v-if="!hasUsername">
    <div class="bv-no-focus-ring" tabindex="-1" role="group">
      <label class="form__label text-muted comments__public-username"
        >It's your first time posting! Set your public username.</label
      >
      <!-- eslint-disable vue/no-mutating-props -->
      <InputWithContextMenu
        v-model="model.username"
        class="form-control"
        placeholder="Enter username here"
        type="text"
        :class="validation.stateClass('username')"
      />
      <!-- eslint-enable vue/no-mutating-props -->
      <FormError :errors="validation.errors" field="username" />
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'

import FormError from '@/components/ui/FormError.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'
import { auth } from '@/services/auth'
import { ValidationState } from '@/helpers/form'

const props = defineProps<{
  model: any
  validation: ValidationState
}>()

const hasUsername = ref(true)

onBeforeMount(() => {
  /* eslint-disable vue/no-mutating-props */
  props.model.username = auth.getUsername()
  /* eslint-enable vue/no-mutating-props */
  if (!props.model.username) {
    hasUsername.value = false
  }
})

function saved(): void {
  const username = auth.getUsername()
  if (username) {
    hasUsername.value = true
  }
}

defineExpose({
  saved,
})
</script>
